module.exports = __webpack_public_path__ + "img/9788961551052.5ae0f30b.jpg";